var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from '../../Components/Modals/Modal';
import { SwipeluxLogo } from './styles';
import styles from './feedback.module.css';
import { CaptionLogo } from '../../Components/Footer/Caption/CaptionLogo';
import { Button } from '../../Components/BaseComponents/Button';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { AwesomeIcon, BadIcon, GoodIcon, NormalIcon, TerribleIcon, } from './Emoji';
var Assessments = [
    {
        name: 'Terrible',
        emoji: _jsx(TerribleIcon, {}),
        value: 1,
    },
    {
        name: 'Bad',
        emoji: _jsx(BadIcon, {}),
        value: 2,
    },
    {
        name: 'Normal',
        emoji: _jsx(NormalIcon, {}),
        value: 3,
    },
    {
        name: 'Good',
        emoji: _jsx(GoodIcon, {}),
        value: 4,
    },
    {
        name: 'Awesome',
        emoji: _jsx(AwesomeIcon, {}),
        value: 5,
    },
];
export var FeedbackModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var track = useAnalytics().track;
    var _b = useState(), rating = _b[0], setRating = _b[1];
    var onSubmit = function () {
        track('Leave feedback on payment', {
            rating: rating,
        });
        onClose();
    };
    return (_jsx(Modal, __assign({ onClose: onClose, label: _jsx(SwipeluxLogo, {}), isOpen: isOpen }, { children: _jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsxs("div", __assign({ className: styles.feedback }, { children: [_jsx("div", __assign({ className: styles.title }, { children: "Order has been completed successfully!" })), _jsx("div", __assign({ className: styles.subtitle }, { children: "Please rate your experience:" })), _jsx("div", __assign({ className: styles.emoji_block_wrapper }, { children: Assessments.map(function (item) {
                                var isActive = rating === item.value;
                                var className = isActive
                                    ? "".concat(styles.emoji_wrapper, " ").concat(styles.active_emoji)
                                    : styles.emoji_wrapper;
                                return (_jsxs("div", __assign({ onClick: function () { return setRating(item.value); }, className: className }, { children: [_jsx("div", __assign({ className: styles.emoji }, { children: item.emoji })), _jsx("div", { children: item.name })] }), item.name));
                            }) }))] })), _jsxs("div", __assign({ className: styles.footer }, { children: [_jsx(Button, { onClick: onSubmit, disabled: !rating, label: "Done" }), _jsxs("a", __assign({ target: "_blank", rel: "noreferrer", href: "https://swipelux.com", className: styles.caption }, { children: [_jsx("span", { children: "Powered by" }), _jsx(CaptionLogo, {})] }))] }))] })) })));
};
